module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "مقدمة"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-family": "Dubai"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مقدِّمة")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أيَّتُها السَّيداتُ الرَّائعات، إنَّه لمن دواعي سروري أنْ تَكُنَّ معي هنا ونحن نبدأ رحلةَ اكتشافِ الذَّاتِ وتطويرِها، والتَّمكين وتعزيزِ الثِّقةِ بالنَّفسِ، يحتاجُ العالمُ من كُلِّ واحدة منكُنَّ أن تحتضن فرديَّتِها وإبرازِها بالكامل؛ لأنَّ كلَّ شخصٍ في هذا العالمِ فريدٌ ومُتميِّزٌ، ويستطيعُ أنْ يُضفِيَ إلى العالم شيئًا مميَّزًا لا يستطيعُ أيُّ شخصٍ آخرَ القيامَ به.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بصفَتِكِ امرأةً، على الأرجح أنَّكِ واجهْتِ تحدِّياتٍ أو تمييزًا في المعاملة في إحدى مراحل حياتِك، أو توقُّعاتٍ مُجتَمعيَّةً جعلت من الصَّعب عليك أنْ تكوني صادقةً مع نفسِكِ، ولكنْ هنا تبدأ رحلتُنا معًا لمساعدتكِ في التَّغلب على هذه التَّحدِّيات واحتضانِ أُنوثتكِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يَكمُنُ جمالُ كونِكِ امرأةً في قدرَتِك على القيام بمهامٍ متعدِّدةٍ، وتَقمُّصِ العديد من الأدوارِ، يمكنُكِ أنْ تكوني أُمًّا، وزوجةً، وأختًا، وابنةً، وصديقةً، وامرأةً عاملةً، وغير ذلك.. ومع ذلك، في أثناء التَّوفيقِ بين كُلِّ هذه الأدوارِ، من المهمِّ أنْ تَتذكَّري دائمًا أنَّه يجبُ عليك أيضًا الاعتناءُ بنفسِكِ وتقبُّل شخصيَّتِكِ في جميع جوانبِ الحياةِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هنا تَظهَرُ أهمِّيَّة آدابِ السُّلوك، لا يتعلَّقُ الأمرُ فقط بكيفيَّةِ تناوُلِ الطَّعام، واللِّباسِ، بل أيضًا بكيفيَّة تصرُّفِكِ في بيئات مُختلفةٍ، لا تتعلَّقُ آدابُ السُّلوكِ أو ما يُعرَفُ بـ(الإتيكيت) بالكمال والمثاليَّةِ، ولكنَّها تتعلَّقُ بفَهمِ واحترامِ الأعرافِ والعاداتِ الاجتماعيَّة، حيثُ يُرسِلُ (الإتيكيت) رسالةً إيجابيَّةً لمن حولِكِ، تُوحي برُقِيِّكِ ورِفعَتِكِ، وتُساعِدُكِ في الحفاظ على صورةٍ ذاتيَّةٍ إيجابيَّةٍ ومُحترَمةٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بالإضافة إلى الآداب، سنستَكشِفُ معًا مبادئَ الثِّقةِ بالنَّفس، واحترامِ الذَّاتِ، وهما أمرانِ أساسيَّان لأيَّ امرأةٍ كي تنجحَ في الحياة، سنتعمَّقُ في التَّفاصيلِ لفهم أسبابِ قِلَّةِ الثِّقةِ أو تَدنِّي احترامِ الذَّاتِ، وسنعمَلُ معًا لتطويرِ حُبُّ الذَّاتِ، وقبولِ النَّفسِ، وتطوير عقليَّةٍ إيجابيَّةٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في أثناء رحلتنا معًا، سنتعمَّقُ أيضًا في الجوانبِ المختلفةِ للأنوثةِ، والَّتي لا تكفُّ عن التَّطوُّرِ يومًا بعدَ يومٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أخيرًا، سنناقِشُ أهميَّةَ تَقبُّلِ أُنوثَتِكِ، وكيف يمكنُ أنْ يُساعِدَكِ ذلكَ على المستوى الشَّخصيِّ والمهنيِّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هذا الكتابُ هو دليلُ كلِّ سيِّدةٍ في كلِّ جانبٍ من جوانبِ الحياةِ، وفي كُلِّ المراحلِ العمريَّةِ، سواءً كنتِ فتاةً شابَّةً في مُقتَبَلِ العُمرِ، أو امرأةً راشِدةً ولديها مسؤوليَّاتٌ، أو أُمًّا نَسِيَتْ هُوِيَّتَها قبلَ أنْ تُنجِبَ أطفالًا، عليكِ أنْ تتذكَّري ولا تنسي أبدًا مَن أنتِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تذكَّري أنَّكِ مُميَّزةٌ، والعالمُ يحتاجُك أنْ تَتَقبَّلي تَفَرُّدَكِ بالكامل، يمكنكِ إلهامُ الآخرين، وتحفيزُهم، وتمكينُهم من خلالِ قِصَّتِكِ ورحلتِكِ في هذه الحياة، يمكنُكِ كَسرُ الصُّورِ النَّمطيَّةِ المنتشرةِ في مجتمعاتنا، والتَّغلُّبُ على أيِّ تحدٍّ يعتَرِضُ طريقَكِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لذا، سيِّدتي العزيزة، هل أنتِ مُستعدَّةٌ لاحتضانِ أنوثَتِك، وتطويرِ آدابكِ، وبناءِ الثِّقةِ بالنَّفس، واحترامِ الذات؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لِنبدأ هذه الرِّحلةَ معًا ونستفِدْ من أنفسنا كنساءٍ؛ لأنَّ العالمَ يحتاجُ إلينا أنْ نكونَ قويَّات، واثقاتٍ، مُتمكِّناتٍ.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ec7193a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 72
// module chunks = 0